/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NftTrackersMetadataBatchBody
 */
export interface NftTrackersMetadataBatchBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof NftTrackersMetadataBatchBody
     */
    ownershipIds: Array<string>;
}

/**
 * Check if a given object implements the NftTrackersMetadataBatchBody interface.
 */
export function instanceOfNftTrackersMetadataBatchBody(value: object): value is NftTrackersMetadataBatchBody {
    if (!('ownershipIds' in value) || value['ownershipIds'] === undefined) return false;
    return true;
}

export function NftTrackersMetadataBatchBodyFromJSON(json: any): NftTrackersMetadataBatchBody {
    return NftTrackersMetadataBatchBodyFromJSONTyped(json, false);
}

export function NftTrackersMetadataBatchBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftTrackersMetadataBatchBody {
    if (json == null) {
        return json;
    }
    return {
        
        'ownershipIds': json['ownershipIds'],
    };
}

export function NftTrackersMetadataBatchBodyToJSON(json: any): NftTrackersMetadataBatchBody {
    return NftTrackersMetadataBatchBodyToJSONTyped(json, false);
}

export function NftTrackersMetadataBatchBodyToJSONTyped(value?: NftTrackersMetadataBatchBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ownershipIds': value['ownershipIds'],
    };
}

